export enum AnchorTypes {
	building = 'building',
	storage = 'storage',
	exit = 'exit',
}
